import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import {Avatar, ListItemAvatar} from "@mui/material";
import {abbr} from "utils/strUtils";

const useStyles = makeStyles(theme => ({
  avatar: {
    backgroundColor: theme.palette.primary.main,
    marginRight:'0.5rem'
  },
  amount: {
    flexGrow: 0
  },
  secondartText:{
    maxWidth:'calc(100vw - 160px)'
  }
}));

export default function AlertListItem({alert, onClick}) {
  const classes = useStyles();

  const {Alert} = alert;
  const {Schedule ={},Text,Color} = Alert;

  const {AssignedTo ={}, Project ={} , JobType} = Schedule;
  const {ProjectName} = Project;
  // const sign = debitCredit === 'CREDIT' ? "+" : "-";
  // const sign = debitCredit === 'CREDIT' ? "-" : "+";


  const handleClick = (e) => onClick && onClick(e);

  return (
      <ListItem dense disableGutters onClick={handleClick}  data-testid={'li-item-'+alert.qAlertId}>
        <ListItemAvatar>
        <Avatar className={classes.avatar}>{abbr(ProjectName)}</Avatar>
        </ListItemAvatar>
        <ListItemText
            primary={ProjectName}
            primaryTypographyProps={{className: 'bold'}}
            secondaryTypographyProps={{className: classes.secondartText}}
            secondary={Text}
        />
      <ListItemText
            primary={JobType}
            className={classes.amount}/>
      </ListItem>
  );
}
